var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-box"
  }, [_c('button', {
    staticClass: "search-box-button",
    on: {
      "click": _vm.toggle
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-box-input",
    class: {
      shown: _vm.shown
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search the site"
    }
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e400d01e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/search-box/search-box.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e400d01e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader/index.js?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/search-box/search-box.vue
// module chunks = index